import { Crown, Quote } from "lucide-react";
import { scrollToId } from "@/components/Reveal";

const ETHOS_QUOTE_URL = "https://agents.ethoslife.com/invite/c31bd";

export const Footer = () => (
  <footer className="border-t border-gold/15 bg-[#0F091A]" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-16 md:grid-cols-3 lg:px-10">
      <div>
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center border border-gold/40 bg-royal/60 text-gold">
            <Crown size={16} strokeWidth={1.5} />
          </span>
          <span>
            <span className="block font-display text-sm font-semibold tracking-[0.22em] text-white">
              VISION ARIES
            </span>
            <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-gold/80">
              Financial Impact
            </span>
          </span>
        </div>
        <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/45">
          Build your legacy with precision and purpose — guided by faith, family, fitness,
          finance, and fun.
        </p>
      </div>
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold/70">Navigate</p>
        <div className="mt-5 flex flex-col gap-3">
          {[
            ["Services", "#services", "footer-link-services"],
            ["Core Values", "#values", "footer-link-values"],
            ["Philosophy", "#philosophy", "footer-link-philosophy"],
            ["Founder", "#founder", "footer-link-founder"],
            ["Join the Team", "#join-team", "footer-link-join-team"],
            ["Request Services", "#contact", "footer-link-contact"],
          ].map(([label, href, testid]) => (
            <button key={href} onClick={() => scrollToId(href)} data-testid={testid}
              className="w-fit text-sm text-white/50 transition-colors duration-300 hover:text-gold">
              {label}
            </button>
          ))}
          <a href={ETHOS_QUOTE_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-quote-link"
            className="flex w-fit items-center gap-2 text-sm text-gold/80 transition-colors duration-300 hover:text-gold-light">
            <Quote size={13} /> Get a Free Life Insurance Quote
          </a>
        </div>
      </div>
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold/70">Connect</p>
        <div className="mt-5 space-y-3 text-sm text-white/50">
          <a href="tel:+17709121516" data-testid="footer-phone-link" className="block transition-colors hover:text-gold">
            +1 (770) 912-1516
          </a>
          <a href="mailto:robertaraehare.gfi@gmail.com" data-testid="footer-email-link" className="block break-all transition-colors hover:text-gold">
            robertaraehare.gfi@gmail.com
          </a>
          <p className="pt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-white/35" data-testid="footer-credentials">
            Roberta Rae Hare · License #21413773
            <br />
            GFI Global Financial Impact — Affiliated
          </p>
        </div>
      </div>
    </div>
    <div className="border-t border-white/5 py-6 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-white/30">
      © 2026 Vision Aries Financial Impact · Faith · Family · Fitness · Finance · Fun
    </div>
  </footer>
);
